/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user-user-profile': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M7.5 2.5a3.125 3.125 0 110 6.25 3.125 3.125 0 010-6.25zm0-1.25a4.375 4.375 0 100 8.75 4.375 4.375 0 000-8.75zm6.25 17.5H12.5v-3.125c0-1.726-1.4-3.125-3.125-3.125h-3.75A3.125 3.125 0 002.5 15.625v3.125H1.25v-3.125a4.375 4.375 0 014.375-4.375h3.75a4.375 4.375 0 014.375 4.375v3.125zm0-16.25H20v1.25h-6.25V2.5zm0 3.125H20v1.25h-6.25v-1.25zm0 3.125h4.375V10H13.75V8.75z"/>'
  }
})
